import React, { ReactNode, useState } from 'react';
import {
  Trigger as RTrigger,
  Header,
  Item,
  Content as RContent,
} from '@radix-ui/react-accordion';
import { getSubComponent } from '../../utils/react.utils';
import Icon from '../icons/icon';

type Props = {
  children: ReactNode;
  value: string;
};

type SubComponentNames = 'Trigger' | 'Content';

function AccordionOption({ children, value }: Props) {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => {
    setIsOpen((prev) => !prev);
  };

  const Trigger = getSubComponent<SubComponentNames>(children, 'Trigger');
  const Content = getSubComponent<SubComponentNames>(children, 'Content');

  return (
    <Item value={value}>
      <Header className="flex">
        <RTrigger
          onClick={() => toggle()}
          className="flex flex-1 justify-between items-center mobile:py-3 tablet-lg:py-4 mobile:px-3 tablet-lg:px-5 hover:bg-white/[2.5%] ease-in transition-colors"
        >
          {Trigger}
          <Icon icon={isOpen ? 'caret-up' : 'caret-down'} size="sm" />
        </RTrigger>
      </Header>
      <RContent className="py-3 mobile:px-3 tablet-lg:px-5 bg-white/[5%]">
        {Content}
      </RContent>
    </Item>
  );
}

type SCProps = {
  children: any;
};

const Trigger = (props: SCProps) => props.children;
const Content = (props: SCProps) => props.children;

Trigger.displayName = 'Trigger';
Content.displayName = 'Content';

AccordionOption.Trigger = Trigger;
AccordionOption.Content = Content;

export default AccordionOption;
